import { lazy, Suspense } from 'react'
import { useSelector } from 'react-redux'
import { BrowserRouter, Routes, Route } from "react-router-dom";

/* import Login from './components/login'
import ForgotPassword from './components/login/forgot-password'
import ResetPassword from './components/login/reset-password'

import PlayerGameInterface from './components/player/PlayerGameInterface.jsx' */

import Header from "./components/header/Header.jsx";

/* import UserManager from './components/users/UserManager.jsx'
import EditUser from './components/users/edit-user.jsx'

import EventTemplateManager from './components/event-template-manager/EventTemplateManager.jsx'

import GameManager from './components/game-manager/GameManager.jsx'

import EventManager from './components/event-manager/EventManager.jsx'

import Profile from './components/profile/Profile.jsx'; */

import './App.scss'

function App() {

 const auth = useSelector(state => state.user);

  const Login = lazy(() => import('./components/login'));
    const ForgotPassword = lazy(() => import('./components/login/forgot-password'));
    const ResetPassword = lazy(() => import('./components/login/reset-password'));
    const PlayerGameInterface = lazy(() => import('./components/player/PlayerGameInterface.jsx'));
    const UserManager = lazy(() => import('./components/users/UserManager.jsx'));
    const EditUser = lazy(() => import('./components/users/edit-user.jsx'));
    const EventTemplateManager = lazy(() => import('./components/event-template-manager/EventTemplateManager.jsx'));
    const GameManager = lazy(() => import('./components/game-manager/GameManager.jsx'));
    const EventManager = lazy(() => import('./components/event-manager/EventManager.jsx'));

  return (
    <>
    <BrowserRouter>
        <Suspense fallback={<span>Loading...</span>}>
        {
            auth.user_type === 'admin' || auth.user_type == 'game_master' ?
                <Header /> : <></>
        }
        {
        auth.user_type === 'admin' ?
            <Routes>
                <Route path="/users/new" element={<EditUser user_id={0} />} />
                <Route path="/users/:user_id" element={<EditUser />} />
                <Route path="/users" element={<UserManager />} />
                <Route path="/event-template-manager" element={<EventTemplateManager />} />
                <Route path="/game-manager" element={<GameManager />} />
                <Route path="/event-manager/:game_id/:event_id" element={<EventManager />} />
                <Route path="*" element={<UserManager />} />
            </Routes>
             :
        auth.user_type === 'game_master' ?
            <Routes>
                <Route path="/game-manager" element={<GameManager />} />
                <Route path="/event-manager/:game_id/:event_id" element={<EventManager />} />
                <Route path="*" element={<GameManager />} />
            </Routes>
             :
        auth.user_type === 'player' ?
            <Routes>
                <Route path="*" element={<PlayerGameInterface />} />
            </Routes> 
            :
            <Routes>
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password/:dtc/:code" element={<ResetPassword />} />
                <Route path="/login/:loginType" element={<Login />} />
                <Route path="*" element={<Login />} />
            </Routes>
        }
        </Suspense>
    </BrowserRouter>
    </>
  )
}

export default App
